import axios from 'axios'
export async function fetchCurrencies(): Promise<{ data: number }> {

  const response = await axios.get('/api/v1/currency_tokens/')
  return response.data
}
